// extracted by mini-css-extract-plugin
export default {"myProfileButton":"D2W+H"};